import { useForm } from "@mantine/form";
import Button from "../../../components/Button";
import Errors from "../../../components/Errors";
import Input from "../../../components/Input";
import CustomTooltip from "../../../components/Tooltip";
import { PipelineImport } from "../../../api/types";
import usePostPipelineImport from "../../../api/usePostPipelineImport";

type AddColumnFormProps = {
  pipelineImport?: PipelineImport;
  onSuccess?: () => void;
};

export default function AddColumnForm({ pipelineImport, onSuccess }: AddColumnFormProps) {
  const form = useForm({
    initialValues: {
      name: "",
      default_value: "",
    },
  });

  const { mutate, isLoading, error } = usePostPipelineImport(pipelineImport?.workspace_id);
  const requiredFieldEmpty = !form.values.name;

  const onSubmit = (values: typeof form.values) => {
    mutate(
      {
        id: pipelineImport?.id || "",
        new_column: {
          name: values.name,
          default_value: values.default_value,
        },
      },
      {
        onSuccess: () => {
          if (onSuccess) onSuccess();
        },
      }
    );
  };

  return (
    <>
      <h2>Add Column</h2>
      <form onSubmit={form.onSubmit(onSubmit)}>
        <div style={{ marginTop: "var(--m)" }}>
          <Input type="text" placeholder="Name" autoComplete="off" label="Name *" required autoFocus {...form.getInputProps("name")} />
        </div>
        <div style={{ marginTop: "var(--m)" }}>
          <Input
            type="text"
            placeholder="None"
            autoComplete="off"
            {...form.getInputProps("default_value")}
            label={
              <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <span>Default Value</span>
                <CustomTooltip title="Set all cells in the column to this value." />
              </div>
            }
          />
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "var(--m-xs)", marginTop: "var(--m)" }}>
          <Button variants={["primary"]} type="submit" disabled={isLoading || requiredFieldEmpty}>
            {isLoading ? "Please wait..." : "Add"}
          </Button>
        </div>
        <Errors error={error} />
      </form>
    </>
  );
}
